import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs/Observable';

import {BaseHttpService} from '../base.service';
import {SessionService} from '../session.service';
import {SearchRankingModel} from '../../../ranking/search-ranking.model';


@Injectable()
export class RankingService extends BaseHttpService {

  private static rankingsData = 'api/ecv/specialists/ranking/';
  private static rankingByKeys = RankingService.rankingsData + 'competences';
  private static rankingByCvs = RankingService.rankingsData + 'phrases_in_cv';

  constructor(sessionService: SessionService, httpClient: HttpClient) {
    super(httpClient, sessionService);
  }

  getRankingByKeys(model: SearchRankingModel): Observable<any> {
    return this.httpPost(RankingService.rankingByKeys, model);
  }

  getRankingByCvs(model: SearchRankingModel): Observable<any> {
    return this.httpPost(RankingService.rankingByCvs, model);
  }
}



// WEBPACK FOOTER //
// C:/Users/Sylwia/Desktop/12.02/ecv_manager_frontend/src/app/core/ecv-http-services/services/ranking.service.ts